"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigEmailIcon = exports.EmailIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const EmailIcon_module_css_1 = __importDefault(require("./EmailIcon.module.css"));
const EnvelopeIcon_svg_1 = __importDefault(require("./EnvelopeIcon.svg"));
const constants_1 = require("../../constants");
/**
 * Email icon.
 * figma link - https://www.figma.com/file/UpS0VG7yUnr0VLopn0wBwx/Sharing-component?node-id=5028%3A13978
 */
function EmailIcon() {
    return ((0, jsx_runtime_1.jsx)("div", { className: EmailIcon_module_css_1.default.iconContainer, children: (0, jsx_runtime_1.jsx)("div", { className: EmailIcon_module_css_1.default.iconStyle, children: (0, jsx_runtime_1.jsx)(EnvelopeIcon_svg_1.default, {}) }) }));
}
exports.EmailIcon = EmailIcon;
/**
 * https://www.figma.com/file/B7QsnUMTNYJuQRRsAnVr0Q/Snapchat%2B-billing-on-the-web?type=design&node-id=1-29780&mode=design&t=6QE4KZmx3HtJDRNP-0
 */
function SigEmailIcon(props) {
    const { className, "data-testid": dataTestId, fill = "#F9C84C", size = constants_1.Sizes.Large } = props;
    return ((0, jsx_runtime_1.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 25", fill: "none", className: className, "data-testid": dataTestId, children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 9.83435C2 8.1775 3.34315 6.83435 5 6.83435H19C20.6569 6.83435 22 8.1775 22 9.83435V17.8344C22 19.4912 20.6569 20.8344 19 20.8344H5C3.34315 20.8344 2 19.4912 2 17.8344V9.83435ZM11.3492 13.9593C11.7237 14.2803 12.2763 14.2803 12.6508 13.9593L18.3492 9.07497C18.7686 8.71555 19.3999 8.76411 19.7593 9.18344C20.1187 9.60276 20.0701 10.2341 19.6508 10.5935L13.9524 15.4778C12.8289 16.4408 11.1711 16.4408 10.0476 15.4778L4.34923 10.5935C3.9299 10.2341 3.88134 9.60276 4.24076 9.18344C4.60018 8.76411 5.23148 8.71555 5.65081 9.07497L11.3492 13.9593Z", fill: fill }) }));
}
exports.SigEmailIcon = SigEmailIcon;
//# sourceMappingURL=EmailIcon.js.map